import { Dialog as MuiDialog, styled } from "@mui/material";

export const DialogPopUp = styled(MuiDialog)`
  .MuiDialog-paper {
    max-width: 600px;
    min-width: 300px;
    background: transparent;
    border-radius: 18px;
    border: 1px solid transparent;
    @media (max-width: 560px) {
      margin: 12px;
      max-width: 300px;
    }
  }
`;
